import React, { useState } from "react";
import { getFileNameWithExtension, ValidationResult } from "sprint-common-web";

import { FileRecordLibrary } from "../../../../../../../common/api/master-api/file-records/details/GetFileRecordDetailsResponse";
import { UpdateFileRecordLibraryRequest } from "../../../../../../../common/api/master-api/file-records/update/library/UpdateFileRecordLibraryRequest";
import { useFileRecordApi } from "../../../../../../../common/api/master-api/file-records/useFileRecordApi";
import { useFileRecordDetailsState } from "../../../../hooks/useFileRecordDetailsState";
import { LibraryForm } from "./EditLibraryForm";

export interface EditLibraryAsideContentProps {
    fileRecordId: string;
    onCancel(): void;
    onSubmit(): void;
}

export const EditLibraryAsideContent = (props: EditLibraryAsideContentProps): JSX.Element => {
    const { fileRecordId, onSubmit, onCancel } = props;

    const { fileRecordDetails, setFileRecordDetails } = useFileRecordDetailsState();
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [validationResult, setValidationResult] = useState<ValidationResult>();
    const { updateFileRecordLibrary } = useFileRecordApi();

    const updateLibrary = (library: FileRecordLibrary) => {
        const request: UpdateFileRecordLibraryRequest = {
            id: fileRecordId,
            library
        };

        setIsLoading(true);

        updateFileRecordLibrary(request)
            .then(() => {
                setFileRecordDetails({
                    ...fileRecordDetails,
                    deliveryFileName: getFileNameWithExtension(library.fileName),
                    deliveryId: library.id,
                    arrivalDate: new Date(library.arrivalDate),
                    originator: library.originator,
                    storageType: library.storageType,
                    reference: library.reference,
                    deliveryPath: library.path
                });

                onSubmit();
            })
            .catch((res) => {
                setValidationResult(res);
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <LibraryForm
            isLoading={isLoading}
            onCancel={onCancel}
            onSubmit={updateLibrary}
            validationResult={validationResult}
        />
    );
};
